import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ.ts";

export const fireMonetateEventIfReferredByPLP = () => {
  const previousUrl = document.referrer;
  const isPLP =
    /(\/search\/|\/brand\/|\/browse\/|\/s\/|\/image-search\/)/i.test(
      previousUrl,
    );

  if (isPLP) {
    dispatchMonetateQEvent("pdp_addToBasketAfterPLP");
  }
};
